import request from '../request';

export default {
  namespaced: true,
  state: {
    hasSeatPlan: false,
    data: {},
    selectedSeats: {},
    priceCategories: [],
    selectedPriceCategories: {},
  },
  mutations: {
    removeSeatsWithoutTicket(state) {
      Object.keys(state.selectedSeats).forEach((k) => {
        if (state.selectedSeats[k].priceId === null) {
          delete state.selectedSeats[k];
        }
      });
    },
    set(state, data) {
      state.priceCategories.length = 0;
      if (data !== false) {
        data.block.forEach((b) => {
          const seatsByRow = {};
          b.seats.forEach((s) => {
            if (typeof seatsByRow[s.row] === 'undefined') {
              seatsByRow[s.row] = [];
            }
            seatsByRow[s.row].push(s);
            if (s.visible !== '0' && !state.priceCategories.includes(s.price_category)) {
              state.priceCategories.push(s.price_category);
              state.selectedPriceCategories[s.price_category] = { selected: true };
            }
          });

          const rowStart = parseInt(b.row_start);
          const rowEnd = parseInt(b.row_end);
          const rowReversed = !isNaN(rowStart) && !isNaN(rowEnd) && rowStart > rowEnd;
          const rowKeys = Object.keys(seatsByRow);
          rowKeys.sort((a, c) =>
            rowReversed ? parseInt(c) - parseInt(a) : parseInt(a) - parseInt(c)
          );

          const seatStart = parseInt(b.seat_number_start);
          const seatEnd = parseInt(b.seat_number_end);
          const seatsReversed = !isNaN(seatStart) && !isNaN(seatEnd) && seatStart > seatEnd;

          b.seatsByRow = seatsByRow;
          b.rowOrder = rowKeys;
        });
        state.data = data;
      }
    },
    setPriceId(state, { seatId, priceId }) {
      const seatKey = Object.keys(state.selectedSeats).find((sskey) => {
        const selectedSeat = state.selectedSeats[sskey].seat;
        const isCorrectId = selectedSeat.id === seatId;
        if (isCorrectId) {
          state.selectedSeats[sskey].priceId = priceId;
        }
        return isCorrectId;
      });
    },
    toggleSeat(state, { seat, block }) {
      if (!state.selectedSeats[seat.id]) {
        state.selectedSeats[seat.id] = {
          selected: true,
          seat: seat,
          priceId: null,
        };
        seat.block = { id: block.id, name: block.name };
      } else {
        delete state.selectedSeats[seat.id];
      }
    },
    togglePriceCategory(state, category) {
      Object.keys(state.selectedPriceCategories).forEach((k) => {
        delete state.selectedPriceCategories[k];
      });
      state.selectedPriceCategories[category.k] = { selected: true };
    },
    resetPriceCategories(state) {
      state.priceCategories.forEach((k) => {
        state.selectedPriceCategories[k] = { selected: true };
      });
    },
    setHasSeatPlan(state, v) {
      state.hasSeatPlan = v;
    },
  },
  actions: {
    get(context, { id, datetime }) {
      return new Promise((resolve) => {
        const { app } = context.rootState;
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.SEAT_PLAN}?event=${id}&datetime=${datetime}`;
        request.make(
          {
            type: 'GET',
            url,
          },
          (err, res) => {
            if (res.ok) {
              let hasSeatPlan = false;
              if (typeof res.body.data !== 'undefined') {
                if (typeof res.body.data.block !== 'undefined') {
                  if (res.body.data.block.length > 0) {
                    context.commit('set', res.body.data);
                    hasSeatPlan = true;
                  }
                }
              }
              context.commit('setHasSeatPlan', hasSeatPlan);
              resolve();
            } else {
              context.commit('setHasSeatPlan', false);
            }
          }
        );
      });
    },
    toggleSeat(context, { seat, block }) {
      if (context.state.selectedSeats[seat.id]) {
        context.dispatch('tickets/removeSeat', { seat: seat }, { root: true });
      }
      context.commit('toggleSeat', { seat, block });
    },
    togglePriceCategory(context, priceCategory) {
      context.commit('togglePriceCategory', priceCategory);
    },
    resetPriceCategories(context) {
      context.commit('resetPriceCategories');
    },
    setPriceId(context, { seatId, priceId }) {
      context.commit('setPriceId', { seatId, priceId });
    },
    removeSeatsWithoutTicket(context) {
      context.commit('removeSeatsWithoutTicket');
    },
  },
  getters: {
    seatCount(state) {
      return Object.keys(state.selectedSeats).length;
    },
    seatPlanForCart(state) {
      let selectedSeatIds = [];
      Object.keys(state.selectedSeats).forEach((selSeatKey) => {
        const selSeat = state.selectedSeats[selSeatKey];
        selectedSeatIds.push(selSeat.seat.id);
      });
      return selectedSeatIds;
    },
    hasMissingPriceId(state) {
      const missingPrice = Object.keys(state.selectedSeats).find((selSeatKey) => {
        return state.selectedSeats[selSeatKey].priceId === null;
      });
      if (typeof missingPrice !== 'undefined') {
        return true;
      }
      return false;
    },
  },
};
